import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeepLTranslated } from '../../hooks/useDeepLTranslated';

/** 현장 추가 요금 안내 — orange alert box with left border accent */
export default function SurchargeNotice({ title, text }) {
  const { t } = useTranslation();
  const bundle = useMemo(() => [title || '', text || ''], [title, text]);
  const [tTitle, tText] = useDeepLTranslated(bundle);
  if (!text) return null;
  return (
    <div className="bg-orange-50 border-l-2 border-orange-600 rounded-xl p-5 flex flex-col gap-4">
      <h3 className="text-lg font-bold text-orange-600">{tTitle || title || t('common.onsite_surcharge_notice')}</h3>
      <p className="text-sm font-normal text-mono-700">{tText || text}</p>
    </div>
  );
}
